export enum WinnerBall {
  BLUE = 'BLUE',
  GOLD = 'GOLD',
  RED = 'RED',
}

export enum WinnerDices {
  RED = 'RED',
  ORANGE = 'ORANGE',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
  BLUE = 'BLUE',
  PURPLE = 'PURPLE',
}

export enum GameType {
  HHH = 'HHH',
  BAC = 'BAC',
  ROULETTE = 'ROULETTE',
}
